import { ref, reactive } from 'vue'

export function useCourseFilters() {
  const filters = reactive({
    search: '',
    category: '',
    courseType: 'default'
  })

  const categories = ref([])
  const parentCategories = ref([])

  const resetFilters = () => {
    filters.search = ''
    filters.category = ''
    filters.courseType = 'default'
  }

  const buildFilterParams = (additionalParams = {}) => {
    return {
      search: filters.search,
      category: filters.category,
      courseType: filters.courseType,
      ...additionalParams
    }
  }

  const loadCategories = async () => {
    try {
      const response = await axios.get('/search/category')
      categories.value = response.data
      
      const arrayParent = []
      const categoriesParent = categories.value.children
      
      for (const k in categoriesParent) {
        if (categoriesParent.hasOwnProperty(k)) {
          arrayParent.push(k)
        }
      }
      
      parentCategories.value = arrayParent
    } catch (error) {
      console.error('Error loading categories:', error)
    }
  }

  return {
    filters,
    categories,
    parentCategories,
    resetFilters,
    buildFilterParams,
    loadCategories
  }
}